var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.444 22.667h22v22h-22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5h33v33h-33v-33zm30.296 25.13c-.24-1.506-1.221-2.77-4.129-3.951-1.012-.475-2.136-.803-2.473-1.566-.125-.455-.143-.7-.062-.97.207-.887 1.26-1.153 2.084-.907.537.165 1.032.577 1.342 1.239 1.421-.93 1.421-.93 2.413-1.547-.372-.576-.557-.827-.805-1.075-.867-.968-2.022-1.463-3.898-1.42l-.968.122c-.93.228-1.816.724-2.352 1.383-1.567 1.774-1.114 4.867.783 6.149 1.875 1.402 4.622 1.71 4.972 3.03.33 1.61-1.195 2.125-2.704 1.94-1.113-.25-1.733-.805-2.413-1.837l-2.515 1.444c.288.659.618.948 1.113 1.526 2.392 2.413 8.374 2.29 9.447-1.383.038-.122.33-.968.102-2.267l.063.09zm-12.351-9.963h-3.091c0 2.664-.013 5.313-.013 7.983 0 1.694.086 3.248-.19 3.727-.454.947-1.625.826-2.155.658-.544-.268-.821-.64-1.142-1.175-.086-.143-.15-.268-.174-.268l-2.508 1.547c.42.867 1.032 1.612 1.822 2.085 1.175.702 2.754.93 4.407.559 1.078-.312 2.008-.952 2.49-1.941.704-1.278.554-2.848.548-4.6.015-2.825 0-5.652 0-8.498l.006-.077z",
    fill: "#EFD81D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.26b5f07b95747737cd35d4d36fed689c.svg";
export { ForwardRef as ReactComponent };